// substitui o pickBy do lodash
export function pickBy(object) {
  const obj = {};
  for (const key in object) {
    if ( object[key] ) {
      if (Array.isArray(object[key]) && !object[key].length) {
        continue;
      }
      obj[key] = object[key];
    }
  }
  return obj;
}
// substitui o get do lodash
export const getE = (obj, path, defaultValue = null) => {
  const result = String.prototype.split.call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (res !== null && res !== undefined) ? res[key] : res, obj);
  return (result === undefined || result === obj) ? defaultValue : result;
};
